import { render, staticRenderFns } from "./ReportsIndex.vue?vue&type=template&id=4d5cfc3f&"
import script from "./ReportsIndex.vue?vue&type=script&lang=js&"
export * from "./ReportsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports